import React, { useEffect, useState, useRef } from 'react';
import './styles.css';
import colors from '../../Utils/colors';
import images from '../../Utils/images';
import CheerioButton from '../../Components/CheerioButton';
import { useDispatch, useSelector } from 'react-redux';
import { getImagePath } from '../../Utils';
import SidemenuNew from './Components/SidemenuNew';
import HEImages from '../../Pages/CreatorNew/Components/HEImages';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import ImportContactsNew from '../ImportContactsNew';
import ProfilePopup from './Components/ProfilePopup';
import ICNewModal from '../ImportContactsNew/Components/ICNewModal';
import AutotopupSuccesModel from './Components/AutotopUpSuccesModel';
import RechargeAfterAutoTopUpsetModal from './Components/RechargeAfterAutoTopUpSet';
import { AiOutlineLeft, AiOutlineRight } from 'react-icons/ai';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { useInView } from 'react-intersection-observer';
import AiAgentFeatureBanner from './../AIAssistant/AiAgentFeatureBanner';
import { IoCloseCircleOutline } from 'react-icons/io5';
import WalletCreditComponent from './WalletCreditComponent';

import {
  AutoSubmitTemplates,
  EmbeddedCheckWAStatus,
  contactlabellistAPI,
  getUserApi,
  loginADMIN,
  userSignupV2Api,
  getProjectQualityStatus,
  getAllSenderId,
  V2SingleGetAgent,
  contactlabellistWithoutCountAPI,
  checkDashboardEvents,
  waStatus,
  switchToPartner,
  trackPage,
  trackLink,
  trackEvent,
  getAllNotifications,
  getAllUnreadNotifications,
  getsetupautorechargedetails,
  workflowAnalytic,
  messageAnalytics,
  emailCreditsPayment,
  saveAiSensyFbToken,
  getShopifyAnalyticsData,
  getShopifyAnalyticsGraphData,
  activateWabaApi,
} from '../../Services';
import FreeTrialModal from '../../Components/Modal/FreeTrialModal';
import SetupWA from '../../Components/Modal/SetupWA';
import SetupSMS from '../../Components/Modal/SetupSMS';
import ProgressBar from 'react-bootstrap/ProgressBar';
import AnnouncementsNew from '../AnnouncementsNew';
import CreatorAnalyticsNew from '../CreatorAnalyticsNew';
import AnnNewModal from '../AnnouncementsNew/Components/AnnNewModal';
import WhatsAppReplies from '../WhatsAppReplies';
import Banner from './Components/Banner';
import WATemplate from '../../Components/Modal/WATemplate';
import ShopifyStore from '../ShopifyStore';
import SetupWebhook from '../../Components/Modal/SetupWebhook';
import Header from './Components/Header';
import Helper from '../../Utils/Helper';
// import SocketConnect from '../../Components/Socket/SocketConnection';
import TimeTriggers from '../TimeTriggers';
import TimeTriggerSetup from '../TimeTriggerSetup';

import styles from './styles.module.css';
import AnnNewComp from '../AnnouncementsNew/Components/AnnNewComp';
import TemplateModal from '../../Components/Modal/TemplateModal';
import ChatBot from '../Chatbot';
import DownloadCredit from '../../Components/Modal/DownloadCredit';
import Templates from '../Templates';
import EventEmitter from '../../Utils/EventEmitter';
import FreeTrialPlans from '../Auth/components/FreeTrialPlans';
import DeploymentBanner from './Components/DeploymentBanner';
import WARefreshModal from '../../Components/Modal/WARefreshModal';
import EmbeddedSignUp from './Components/EmbeddedSignUp';
import EmbeddedModal from './Components/EmbeddedModal';
import CreateTemplate from '../CreateTemplate';
import EmbeddedStatusModal from './Components/EmbeddedStatusModal';
import { SenderIdModal } from './Components/SenderIdModal';
import { ManageSender } from '../ManageSender';
import { MdArrowForwardIos } from 'react-icons/md';

import EmailBuilder from '../EmailBuilder';
import { toast } from 'react-toastify';
import CustomTemplateStart from '../CustomTemplate/CustomTemplate';
import MyTemplates from '../Templates/Components/MyTemplates';
import ExploreTemplates2 from '../Templates/Components/ExploreTemplates2';
import ContactModule from '../ContactModule';
import { googleLogout } from '@react-oauth/google';
import AddPeopleModal from '../ManageProfile/Components/AddPeopleModal';
import { Broadcast } from './Components/Broadcast';
import WooCommerce from '../WooCommerce';
import METAEmbeddedSignUp from './Components/METAEmbeddedSignUp';
import { Tooltip } from '@mui/material';
import { NewLoader } from '../../Components/SpinnerLoader';
import QRTile from './Components/QRTile';
import QRModal from './Components/QRModal';
import WorkFlow from '../WorkFlow';
import WorkflowTabels from '../WorkflowTabels';
import { eventsend } from '../../Config/analyticsFunctions';
import CreditsTile from './Components/CreditsTile';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccordianItems from './Components/AccordianItems';
import ReactPlayer from 'react-player';
import BroadcastNew from './Components/BroadcastNew';
import PremiumTile from './Components/PremiumTile';
import AgentPermModal from './Components/AgentPermModal';
import { BiBarChartAlt2 } from 'react-icons/bi';
import WAPreSetupModal from './Components/WAPreSetupModal';
import SMSDLTModal from './Components/SMSDLTModal';
import { GptComponent } from './Components/GptComponent';
import { MessengerReplies } from '../MessengerReplies/MessengerReplies';
import EmailBuild from '../Templates/Components/EmailBuild';
import InstagramReplies from '../InstagramReplies';
import GlobalAnalytics from '../GlobalAnalytics';
import { DiscoverPlatforms } from '../Integrations/DiscoverPlatforms';
import ManageIntegrations from '../Integrations/ManageIntegrations';
import { Beacon } from '@beacon.li/bar';
import { IoIosSearch } from 'react-icons/io';
import { RxCrossCircled } from 'react-icons/rx';
import Keywords from '../Keywords';
import AgentAnalytics from '../AgentAnalytics';
import { MdOutlineOpenInNew } from 'react-icons/md';
import AddTopUpModal from './Components/AddTopUpModal';
import HistoryModal from './Components/HistoryModal';
import CheerioWidget from './Components/CheerioWidget';
import ReferralModal from './Components/ReferralModal';
import ReferralBanner from './Components/ReferralBanner';
import AppsumoWelcomeModal from './Components/AppsumoWelcomeModal';
import PreReqWASetup from './Components/PreReqWASetup';
import { trackPages, handleTrackEvent, handleTrackLinks } from '../../Utils/brevo';
import WarningModal from './Components/WarningModal';
import AppSumoReviewModal from './Components/AppsumoReviewModal';
import { CodPrepaidFlow } from '../ShopifyStore/Components/CodPrepaidFlow';
import BounceWarningModal from './Components/BounceWarningModal';
import { Catalog } from '../WhatsappCommerce/Catalog';
import NotificationModal from './Components/NotificationModal';
import { ContactMapping } from '../ContactModule/ContactMapping/ContactMapping';
import EmbeddableForms from '../EmbeddableForms';
import { DefaultCurrencyModal } from './Components/DefaultCurrencyModal';
import AddINRTopUpModal from './Components/AddINRTopupModal';
import PremiumModal from './Components/PremiumModal';
import AutomaticRechargeModal from './Components/AutomaticRecharge';
import AutomationTaskModal from './Components/AutomationTaskModal';
import OneTimeRechargeSuccessmodel from './Components/OneTimeRechargeSuccessmodel';
import ExcelUpload from '../ExcelUpload';
import VendorList from '../VendorList';
import SequenceHome from '../LinkedinSequence';
import Sequences from '../Sequences';
import ManageIntegrationsPage from '../Integrations/ManageIntegrationsPage';
import { LiaWalletSolid } from 'react-icons/lia';
import { FaGreaterThan } from 'react-icons/fa';
import Card from './Components/Card';
import GraphComponent from '../AgentAnalytics/Components/GraphComponent';
import GraphChartComponent from './Components/GraphChart';
import HelperVideos from './Components/HelperVideos';
import AppSumoAccodians from './Components/AppSumoAccordians';
import BetaFeatureBanner from '../../Components/BetaFeatureBanner';
import EmailVerifier from '../EmailVerifier';
import MetaAds from '../MetaAds';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import WhatsAppSetupModal from './Components/WhatsAppSetupComplete';
import AIAssistantList from '../AIAssistant';
import CreateAssistantPage from '../AIAssistant/CreateAssistant';
import TokenUsagePage from '../AIAssistant/TokenUsagePage';
import { FaArrowRight } from 'react-icons/fa6';
import RCSIntegration from '../RCSIntegration';
import RCSTemplateCreation from '../RCSTemplateCreation';
import NewRcsCampaignModal from '../RCSCampaign/RCSCampaignModal';
import WorkflowTemplatePreview from '../WorkflowTabels/WorkflowLibrary/WorkflowTemplatePreview';
import ChannelChecklist from '../OmnyboxOnly/ChannelChecklist';
import WalletModalOB from '../OmnyboxOnly/WalletModalOB';
import SetupChannelNew from '../SetupChannels';

const BuyCreditsModal = ({ isOpen, onClose, availableBalance, walletCurrency, authtoken }) => {
  const [credits, setCredits] = useState('');
  const [error, setError] = useState('');

  const CREDIT_COST = walletCurrency === 'INR' ? 0.15 : 0.002;
  const MAX_CREDITS = 10000000;

  const calculateRequiredBalance = () => {
    return Number((credits * CREDIT_COST).toFixed(2));
  };

  const handleCreditsChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, '');

    const numValue = Number(value);

    if (numValue > MAX_CREDITS) {
      setCredits(MAX_CREDITS.toString());
      setError('Maximum limit is 1 crore credits');
      return;
    }

    setCredits(value);

    if (numValue <= 0) {
      setError('Please enter a valid number of credits');
      return;
    }

    const requiredBalance = calculateRequiredBalance();
    if (requiredBalance > availableBalance) {
      setError("You don't have enough wallet balance");
    } else {
      setError('');
    }
  };

  const handleBuyCredits = async () => {
    if (!error && credits) {
      try {
        const response = await emailCreditsPayment({ credits: Number(credits) }, authtoken);
        console.log('response', response);
        if (response && response.flag) {
          toast.success('Credits purchased successfully');
          setTimeout(() => {
            window.location.reload();
          }, 3000);
          onClose();
        } else {
          toast.error(response?.message || 'Failed to purchase credits');
        }
      } catch (error) {
        console.log(error);
        toast.error('An error occurred while purchasing credits');
      }
    }
  };

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
      }}
    >
      <div
        style={{
          backgroundColor: 'white',
          padding: '20px',
          borderRadius: '10px',
          width: '500px',
          position: 'relative',
        }}
      >
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            background: 'none',
            border: 'none',
            fontSize: '20px',
            cursor: 'pointer',
          }}
        >
          ×
        </button>
        <p
          style={{
            fontWeight: 700,
            fontSize: 16,
            color: '#000000',
          }}
        >
          Buy Credits
        </p>
        <hr
          style={{
            color: '#F0F0F0',
          }}
        />

        <div style={{ marginBottom: '15px' }}>
          <label
            style={{
              fontWeight: 700,
              fontSize: 14,
              color: '#000000',
            }}
          >
            Email credits
          </label>
          <input
            type="text"
            value={credits}
            onChange={handleCreditsChange}
            placeholder="Enter email credits you want to buy"
            style={{
              width: '100%',
              padding: '10px',
              marginTop: '5px',
              border: error ? '1px solid red' : '1px solid #ccc',
              borderRadius: '5px',
            }}
          />
          {error && (
            <p
              style={{
                color: 'red',
                marginTop: '5px',
                fontSize: '14px',
              }}
            >
              {error}
            </p>
          )}
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: '15px',
          }}
        >
          <span
            style={{
              fontWeight: 700,
              fontSize: 14,
              color: '#000000',
            }}
          >
            Required wallet Balance:
          </span>
          <span>
            {walletCurrency === 'INR' ? '₹' : '$'}
            {calculateRequiredBalance()}
          </span>
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: '15px',
          }}
        >
          <span
            style={{
              fontWeight: 700,
              fontSize: 14,
              color: '#000000',
            }}
          >
            Available wallet Balance:
          </span>
          <span>
            {walletCurrency === 'INR' ? '₹' : '$'}
            {availableBalance}
          </span>
        </div>

        <button
          onClick={handleBuyCredits}
          disabled={!!error || !credits}
          style={{
            width: '100%',
            padding: '10px',
            backgroundColor: colors.themeDarkBlue,
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: error || !credits ? 'not-allowed' : 'pointer',
            opacity: error || !credits ? '0.5' : '1',
          }}
        >
          Buy Credits
        </button>
      </div>
    </div>
  );
};

const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
  <div style={inputStyles} onClick={onClick} ref={ref}>
    <span style={{ flexGrow: 1 }}>{value || 'Select Date'}</span>
    <img src={images.CalanderIcon} style={{ height: 18, width: 18, objectFit: 'contain' }} alt="Calendar Icon" />
  </div>
));

const inputStyles = {
  display: 'flex',
  fontSize: '14px',
  alignItems: 'center',
  border: '1px solid #ced4da',
  borderRadius: '4px',
  padding: '6px 8px',
  cursor: 'pointer',
  width: '120px',
  backgroundColor: 'white',
  color: '#495057',
};

const EMAIL_STEPS = [
  { id: 'createSender', label: 'Create a sender ID', href: '/creator/setup/email' },
  { id: 'warmup', label: 'Configure email warmup', href: '/creator/manageSender' },
  { id: 'verifyList', label: 'Verify email recipient’s list', href: '/creator/emailVerifier' },
  { id: 'campaign', label: 'Create an email campaign' },
  { id: 'sequence', label: 'Create an email sequence', href: '/creator/sequences' },
];

const INSTAGRAM_STEPS = [
  { id: 'connectFBM', label: 'Connect your Facebook Business Manager', href: '/creator/setup/instagram' },
  { id: 'webhooks', label: 'Configure Webhooks for Instagram Inbox', href: '/creator/instagramReplies' },
  { id: 'storyAuto', label: 'Automate your story replies' },
  { id: 'commentAuto', label: 'Automate your comment replies' },
  { id: 'dmAuto', label: 'Automate your DM Replies' },
];

const META_STEPS = [
  { id: 'connectManager', label: 'Connect your Meta Ads Manager', href: '/creator/setup/metaAds' },
  { id: 'createCTDM', label: 'Create Click-to-DM Ads', href: '/creator/metaAds' },
  { id: 'setupOptimization', label: 'Setup Ad optimization (Purchase, Lead, Traffic)', href: '/creator/metaAds' },
  { id: 'configurePixel', label: 'Configure meta pixel', href: '/creator/discoverPlatforms/facebookPixel' },
];

const RCS_STEPS = [
  { id: 'verifyBusiness', label: 'Setup your RCS Business Verification', href: '/creator/rcsIntegration' },
  { id: 'createCampaign', label: 'Create an RCS Campaign', href: '/creator/rcstemplates/create' },
];

const SMS_STEPS = [
  { id: 'registerBusiness', label: 'Register your business with SMS (Local/International)', href: '/creator/setup/sms' },
  { id: 'uploadTemplateDump', label: 'Upload a Template Dump for verification', href: '/creator/setup/email' },
  { id: 'publishCampaign', label: 'Create and Publish your first SMS Campaign', href: '/creator/announcements' },
];

const CreatorNew = () => {
  const localdata = useSelector((state) => state.main.localdata);
  const agentdata = useSelector((state) => state.main.agentdata);
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [lastPath, setLastPath] = useState(null);
  const [profilePopup, setProfilePopup] = useState(false);
  const [openICModal, setOpenICModal] = useState(false);
  const [openWATemplate, setOpenWATemplate] = useState(false);
  const [authToken, setAuthToken] = useState('');
  const [isFTMOpen, setIsFTMOpen] = useState(false);
  const [isFTPOpen, setIsFTPOpen] = useState(false);
  const [isWAOpen, setIsWAOpen] = useState(false);
  const [isWebhookOpen, setIsWebhookOpen] = useState(false);
  const [isTemplateOpen, setIsTemplateOpen] = useState(false);
  const [isSMSOpen, setIsSMSOpen] = useState(false);
  const [isWARefreshOpen, setIsWARefreshOpen] = useState(false);
  const [isEmbeddedModalOpen, setIsEmbeddedModalOpen] = useState(false);
  const [isAddTopUpModalOpen, setIsAddTopUpModalOpen] = useState(false);
  const [isPaymentSuccessModalOpen, setIsPaymentSuccessModalOpen] = useState(false);
  const [isonetimerechargeSucceesmodelopen, setIsonetimerechargeSucceesmodelopen] = useState(false);
  const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false);
  const [openANModal, setOpenANModal] = useState(false);
  const [ANMEMailBuilder, setANMEmailBuilder] = useState(false);
  const [uploadHTMLHome, setUploadHTMLHome] = useState(false);
  const user_pic = useSelector((state) => state.main.user_pic);
  const _id = useSelector((state) => state.main._id);
  const authtoken = useSelector((state) => state.main.auth_token);
  const tempFBToken = useSelector((state) => state.main.tempFBToken);
  const username = useSelector((state) => state.main.username);
  const [labelList, setLabelList] = useState([]);
  const [sidemenuCollapse, setSidemenuCollapse] = useState(false);
  const [autoSubmit, setAutoSubmit] = useState(false);
  const [proceedtoTemplate, setProceedtoTemplate] = useState(false);
  const [isDownloadCreditOpen, setIsDownloadCreditOpen] = useState(false);
  const [FTPSuccess, setFTPSuccess] = useState(false);
  const [EmbeddedLink, setEmbeddedLink] = useState('');
  const [EmbeddedOpen, setEmbeddedOpen] = useState(false);
  const [WAStatus, setWAStatus] = useState(false);
  const [waQualityStatus, setWaQualityStatus] = useState(null);
  const [openSenderIdModal, setOpenSenderIdModal] = useState(false);
  const [senderId, setSenderId] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [expanded, setExpanded] = useState(true);

  const [isAPModalOpen, setIsAPModalOpen] = useState(false);
  const [isAgentPermModalOpen, setIsAgentPermModalOpen] = useState(false);
  const [isWAPresetupModalOpen, setIsWAPresetupModalOpen] = useState(false);
  const [setupComplete, setSetupComplete] = useState(false);
  const [count, setCount] = useState(0);

  const [isQRModalOpen, setIsQRModalOpen] = useState(false);
  const [DashboardEvent, setDashboardEvent] = useState([]);

  const [isSMSDLTModalOpen, setIsSMSDLTModalOpen] = useState(false);
  const [showGpt, setShowGpt] = useState(false);
  const [waStatusData, setWaStatusData] = useState();
  const [showSearchBar, setShowSearchBar] = useState(true);
  const [isReferralModalOpen, setIsReferralModalOpen] = useState(false);
  const [showReferralBanner, setShowReferralBanner] = useState(Helper.ReferralBanner);
  const [sumowelcome, setSumoWelcome] = useState(true);
  const [showWelcomeModal, setShowWelcomeModal] = useState(false);
  const [PRWAModalOpen, setPRWAModalOpen] = useState(false);
  let walletBalance = localdata?.walletBalance ? Number(localdata.walletBalance.toFixed(3)) : 0;
  const walletCurrency = localdata?.walletCurrency || null;
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [isBounceModalOpen, setIsBounceModalOpen] = useState(true);
  const [showCurrencyDefaultModal, setShowDefaultCurrencyModal] = useState(false);
  const [showPremiumModal, setShowPremiumModal] = useState(false);
  const [rechargeafterAutotopupsetModel, setrechargeafterAutotopupsetModel] = useState(false);
  const [autorechargdata, setautorechargdata] = useState([]);
  const [workflowAnalytics, setWorkflowAnalytics] = useState([]);
  const [emailModalOpen, setEmailModalOpen] = useState(false);
  const [messageAnalyticsData, setMessageAnalyticsData] = useState([]);
  const [showAiAgentFeatureBanner, setShowAiAgentFeatureBanner] = useState(false);
  const [isAutomationTaskModalOpen, setIsAutomationTaskModalOpen] = useState(false);
  const [showBanner, setShowBanner] = useState(true);

  const [walletOBModalOpen, setWalletOBModalOpen] = useState(false);

  // delete this
  const [RCSModalOpen, setRCSModalOpen] = useState(false);

  const [opencampaignmodal, setOpenCampaignModal] = useState(false);
  const hideAnalytics =
    localdata?._id === '671ce3adf954d69eaef89be1' ||
    localdata?._id === '671cdedcf954d69eaef494cf' ||
    localdata?._id === '671ccb67f954d69eaeeba49f' ||
    localdata?._id === '6719309f3beb1c2c7b154326' ||
    localdata?._id === '66d94723e94b89869e2c46af' ||
    localdata?._id === '67319ae99fb52a43f93b45cb' ||
    localdata?._id === '672f45779fb52a43f998cfa7';

  const hasShopifyAnalytics = true;

  const [emailSetupNew, setEmailSetupNew] = React.useState({
    senderIdCreated: false,
    warmupConfigured: false,
    recipientsVerified: false,
    campaignCreated: false,
    sequenceCreated: false,
  });

  const emailCompletion = {
    createSender: emailSetupNew.senderIdCreated,
    warmup: emailSetupNew.warmupConfigured,
    verifyList: emailSetupNew.recipientsVerified,
    campaign: emailSetupNew.campaignCreated,
    sequence: emailSetupNew.sequenceCreated,
  };

  const [ig, setIg] = React.useState({
    fbmConnected: false,
    inboxWebhooksConfigured: false,
    storyAutomationEnabled: false,
    commentAutomationEnabled: false,
    dmAutomationEnabled: false,
  });

  const igCompletion = {
    connectFBM: ig.fbmConnected,
    webhooks: ig.inboxWebhooksConfigured,
    storyAuto: ig.storyAutomationEnabled,
    commentAuto: ig.commentAutomationEnabled,
    dmAuto: ig.dmAutomationEnabled,
  };

  const [meta, setMeta] = React.useState({
    managerConnected: false,
    ctdmCreated: false,
    optimizationSetup: false,
    pixelConfigured: false,
  });

  const metaCompletion = {
    connectManager: meta.managerConnected,
    createCTDM: meta.ctdmCreated,
    setupOptimization: meta.optimizationSetup,
    configurePixel: meta.pixelConfigured,
  };

  const [rcs, setRcs] = React.useState({
    businessVerified: false,
    campaignCreated: false,
  });

  const rcsCompletion = {
    verifyBusiness: rcs.businessVerified,
    createCampaign: rcs.campaignCreated,
  };

  const [sms, setSms] = React.useState({
    businessRegistered: false,
    templateDumpUploaded: false,
    firstCampaignPublished: false,
  });

  const smsCompletion = {
    registerBusiness: sms.businessRegistered,
    uploadTemplateDump: sms.templateDumpUploaded,
    publishCampaign: sms.firstCampaignPublished,
  };

  useEffect(() => {
    if (DashboardEvent?.[0]?.Email) {
      setEmailSetupNew((prev) => ({ ...prev, senderIdCreated: true }));
    }
    if (DashboardEvent[0]?.Sms?.length > 0) {
      setSms((prev) => ({ ...prev, businessRegistered: true }));
    }
    if (DashboardEvent[0]?.Rcs) {
      setRcs((prev) => ({ ...prev, businessVerified: true }));
    }
  }, [DashboardEvent]);

  useEffect(() => {
    if (localdata?.metaConfig?.newIGToken) {
      setIg((prev) => ({ ...prev, fbmConnected: true }));
    }
  }, [localdata]);

  const handleChecklistAction = (step) => {
    if (!step) return;
    switch (step.id) {
      case 'storyAuto':
        navigate('/workflow', {
          state: {
            templateName: 'Automate story replies',
          },
        });
        break;
      case 'commentAuto':
        navigate('/workflow', {
          state: {
            templateName: 'Reply to comments',
          },
        });
        break;
      case 'dmAuto':
        navigate('/workflow', {
          state: {
            templateName: 'Auto-DM Links from comments',
          },
        });
        break;
      case 'campaign':
        if (!agentdata?.permission?.campaign && agentdata && isPremiumUser) {
          setIsAgentPermModalOpen(true);
        } else if (isPremiumUser) {
          setANMEmailBuilder(true);
          setUploadHTMLHome(true);
          setOpenANModal(true);
        } else {
          setIsFTMOpen(true);
        }
        break;
      default:
        console.log('No action mapped for step:', step.id);
    }
  };

  const onBlocked = (label) => toast.info(`Finish the previous step(s) before “${label}”.`);

  const handleClose = () => {
    setIsModalOpen(false);
  };
  const handleBounceModalClose = () => {
    setIsBounceModalOpen(false);
  };

  useEffect(() => {
    if (localStorage.getItem('isAiAgentFeatureBannerSeen') === 'true') {
      setShowAiAgentFeatureBanner(false);
    } else {
      setShowAiAgentFeatureBanner(true);
    }
  }, []);

  const [openNotificationModal, setOpenNotificationModal] = useState(false);
  const [allNotifications, setAllNotifications] = useState([]);
  const [unreadNotifications, setUnreadNotifications] = useState([]);
  const notificationIconRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState('all');
  const [readStatus, setReadStatus] = useState(false);
  const [selectedDuration, setSelectedDuration] = useState('7');
  const [analyticsData, setAnalyticsData] = useState();
  const [SAGraphData, setSAGraphData] = useState();
  const [graphLoading, setGraphLoading] = useState(false);
  const [channel, setChannel] = useState('whatsapp');
  const [messageDays, setMessageDays] = useState(7);
  const [chatbotDays, setChatbotDays] = useState(7);
  const [shopifyLoading, setShopifyLoading] = useState(false);
  const [chatbotLoading, setChatbotLoading] = useState(false);
  const [messageLoading, setMessageLoading] = useState(false);
  const [isChannelActive, setIsChannelActive] = useState(false);
  const [chatbotStartDate, setChatbotStartDate] = useState(new Date());
  const [messageStartDate, setMessageStartDate] = useState(new Date());
  const [messageEndDate, setMessageEndDate] = useState(new Date());
  const [chatbotEndDate, setChatbotEndDate] = useState(new Date());
  const [chatbotRef, inView] = useInView({ triggerOnce: true }); // trigger only once
  const [hasFetched, setHasFetched] = useState(false);
  const [cachedAnalytics, setCachedAnalytics] = useState(null);
  const [messageRef, messageInView] = useInView({ triggerOnce: true });
  const [hasFetchedMessageAnalytics, setHasFetchedMessageAnalytics] = useState(false);
  const [cachedMessageAnalytics, setCachedMessageAnalytics] = useState(null);

  const defaultIds = ['6489675b4f598e055ed74e34', '64f6fc44a8ab1b1d3eaa8d2c'];
  const isDefaultId = defaultIds?.includes(localdata?._id);

  useEffect(() => {
    getSAGraphDataAPIcall();
  }, []);

  useEffect(() => {
    getSADataAPIcall();
  }, [selectedDuration]);

  const getSAGraphDataAPIcall = () => {
    setGraphLoading(true);
    let token = authtoken;
    getShopifyAnalyticsGraphData(token).then((res) => {
      if (res?.flag) {
        setSAGraphData(res?.data);
        // console.log("3333333333 ", res);
      } else {
        console.log('Failed to fetch analytics graph data, please try again later', { autoClose: true, position: 'top-right' });
        // console.log("3333333333 ", res);
      }
      setGraphLoading(false);
    });
  };

  const toLowerCaseKeys = (obj) => {
    if (!obj || typeof obj !== 'object') return {}; // Handle null/undefined input

    return Object.fromEntries(Object.entries(obj).map(([key, value]) => [key.toLowerCase(), value]));
  };

  const isChannelValid = (channel, data = []) => {
    if (!Array.isArray(data) || data.length === 0) return false;

    const lowerCaseData = toLowerCaseKeys(data[0]);
    if (!lowerCaseData) return false;

    const value = lowerCaseData[channel.toLowerCase()];

    if (Array.isArray(value)) {
      return value.includes('completed');
    }

    return value === true || value === 'completed';
  };

  useEffect(() => {
    const isChannelAct = isChannelValid(channel, DashboardEvent);
    setIsChannelActive(isChannelAct);
  }, [channel, DashboardEvent]);

  const videos = [
    { link: 'https://youtu.be/-4GgFEtSDV0?si=Kiyp5TuhmjmeF85B', title: 'How to upload contact and shoot a campaign on Cheerio AI' },
    { link: 'https://www.youtube.com/watch?v=SrxHNa0zvRU&t=13s', title: 'How to use Cheerio AI to increase revenue by upto 56%' },
    { link: 'https://youtu.be/oIYfVDgIE74', title: 'How to create and submit a WhatsApp Messaging Template on Cheerio AI' },
    { link: 'https://www.youtube.com/watch?v=bd4gWa947dQ', title: 'How to create a workflow using keywords on Cheerio AI' },
    { link: 'https://www.youtube.com/watch?v=FSjY8MoeEfI', title: 'How to create a sharable or embeddable form using Cheerio AI' },
    { link: 'https://www.youtube.com/watch?v=HiwGN4ZwBQU', title: 'Creating and Deploying GPT assistant on your WABA using Cheerio AI' },
  ];

  const activateWabaApiCall = (retryCount = 0) => {
    let token = authtoken;
    activateWabaApi(token)
      .then((res) => {
        if (res?.flag) {
          if (res?.data?.wabaActivated) {
            getuserapicall();
          } else if (!res?.data?.techProviderTokenValid) {
            window.FB.login(
              function (response) {
                if (response.authResponse) {
                  const code = response.authResponse.accessToken;
                  dispatch({ type: 'tempFBToken', payload: code });
                  saveTokenApiCall(code, retryCount);
                } else {
                  console.log('User cancelled login or did not fully authorize.');
                }
              },
              {
                scope: 'whatsapp_business_management',
                extras: {
                  feature: 'whatsapp_embedded_signup',
                  setup: { solutionID: '883160333502568' },
                },
              }
            );
          }
        } else {
          toast.error(res?.error, { position: 'top-center', autoClose: 3000 });
        }
      })
      .catch((err) => {
        console.error('Error in activateWabaApiCall:', err);
      });
  };

  const saveTokenApiCall = (fbToken, retryCount = 0) => {
    if (retryCount >= 3) {
      toast.error('Max retry attempts reached');
      return;
    }

    let token = authtoken;
    const data = { fbToken };

    saveAiSensyFbToken(data, token)
      .then((res) => {
        if (res?.flag) {
          activateWabaApiCall(retryCount + 1);
        }
      })
      .catch((err) => {
        console.error('Error in saveTokenApiCall:', err);
      });
  };

  const getSADataAPIcall = () => {
    const today = new Date();
    const endDate = today.toISOString().split('T')[0]; // Format: YYYY-MM-DD

    const daysToSubtract = parseInt(selectedDuration ?? 7, 10);
    const startDate = new Date(today);
    startDate.setDate(today.getDate() - daysToSubtract);
    const formattedStartDate = startDate.toISOString().split('T')[0];

    let token = authtoken;
    let data = {
      startDate: formattedStartDate,
      // endDate: endDate,
    };
    setShopifyLoading(true);
    getShopifyAnalyticsData(token, data).then((res) => {
      if (res?.flag) {
        setAnalyticsData(res?.data);
        setShopifyLoading(false);
        // console.log("22222222222 ", res)
      } else {
        setShopifyLoading(false);
        console.log('Failed to fetch analytics data, please try again later', { autoClose: true, position: 'top-right' });
        // console.log("222222222223333 ", res)
      }
    });
  };
  const formatISTDate = (date) => {
    const istOffset = 5.5 * 60 * 60 * 1000;
    const istDate = new Date(date.getTime() + istOffset);
    const year = istDate.getUTCFullYear();
    const month = (istDate.getUTCMonth() + 1).toString().padStart(2, '0');
    const day = istDate.getUTCDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  const workflowAnalyticFunc = async () => {
    let token = authtoken;
    const startDate = chatbotStartDate ? formatISTDate(chatbotStartDate) : '';
    const endDate = chatbotEndDate ? formatISTDate(chatbotEndDate) : '';
    setChatbotLoading(true);
    try {
      const res = await workflowAnalytic(startDate, endDate, token);
      if (res?.flag) {
        setCachedAnalytics(res?.data);
        setWorkflowAnalytics(res?.data);
        setHasFetched(true);
      }
    } catch (err) {
      console.error('Error fetching workflow analytics', err);
    } finally {
      setChatbotLoading(false);
    }
  };

  const messageAnalyticsReport = async () => {
    let token = authtoken;
    const startDate = messageStartDate ? formatISTDate(messageStartDate) : '';
    const endDate = messageEndDate ? formatISTDate(messageEndDate) : '';
    setMessageLoading(true);
    try {
      const res = await messageAnalytics(startDate, endDate, token, channel);
      if (res?.flag) {
        setMessageAnalyticsData(res?.data);
        setMessageLoading(false);
        setHasFetchedMessageAnalytics(true);
        setCachedMessageAnalytics(res?.data);
      }
    } catch (err) {
      setMessageLoading(false);
      console.log('Error fetching messageAnalyticsReport', err);
    } finally {
      setMessageLoading(false);
    }
  };

  useEffect(() => {
    if (chatbotDays && chatbotDays !== '') {
      const days = parseInt(chatbotDays);
      const end = new Date();
      const start = new Date();
      start.setDate(end.getDate() - (days - 1));
      setChatbotStartDate(start);
      setChatbotEndDate(end);
    }
  }, [chatbotDays]);

  useEffect(() => {
    if (inView && !hasFetched) {
      console.log('API called');
      workflowAnalyticFunc();
    }
  }, [inView, hasFetched, chatbotStartDate, chatbotEndDate]);

  useEffect(() => {
    if (messageDays && messageDays !== '') {
      const days = parseInt(messageDays);
      const end = new Date();
      const start = new Date();
      start.setDate(end.getDate() - (days - 1));
      setMessageStartDate(start);
      setMessageEndDate(end);
    }
  }, [messageDays]);

  useEffect(() => {
    if (messageInView && !hasFetchedMessageAnalytics) {
      messageAnalyticsReport();
    }
  }, [messageInView, hasFetchedMessageAnalytics, messageStartDate, messageEndDate, channel]);

  const fetchNotifications = async () => {
    try {
      setLoading(true);
      if (selectedTab === 'all') {
        const res = await getAllNotifications(authtoken);
        if (res?.flag) {
          setAllNotifications(res?.data);
          const read = res?.data?.some((notification) => notification?.isRead === false);
          setReadStatus(read);
        }
      } else {
        const res = await getAllUnreadNotifications(authtoken);
        if (res?.flag) {
          setUnreadNotifications(res?.data);
        }
      }
    } catch (err) {
      console.log('Error fetching notifications', err);
    } finally {
      setLoading(false);
    }
  };
  const fetchautorechargedetails = async () => {
    try {
      const res = await getsetupautorechargedetails(authtoken);
      if (res?.flag && res?.data) {
        setautorechargdata(res.data);
      }
    } catch (err) {
      console.log('Error fetching notifications', err);
    }
  };
  useEffect(() => {
    return () => setLastPath(location?.pathname);
  }, [location]);

  useEffect(() => {
    if (lastPath === '/creator/design' && location?.pathname === '/creator' && opencampaignmodal) {
      setOpenANModal(true);
    }
  }, [location?.pathname, lastPath]);

  useEffect(() => {
    fetchautorechargedetails();
  }, []);

  useEffect(() => {
    fetchNotifications();
  }, [selectedTab]);

  const [showreviewModal, setShowreviewModal] = useState(false);
  // useEffect(() => {
  //   //adminLogin();
  //   !Helper.isSocketConnect && SocketConnect.socketDataEvent('addPerson', localdata?._id);
  //   console.log('Helper is socket connected ', Helper.isSocketConnect);
  // }, []);
  const MobileWidth = window.innerWidth < 700 ? true : false;
  const TabWidth = window.innerWidth < 1200 ? true : false;
  useEffect(() => {
    eventsend('creator_home_pageview_web');
    checkDashboardAPICall();

    if (MobileWidth) {
      setSidemenuCollapse(true);
    }
  }, [isSMSDLTModalOpen, window.innerWidth]);

  const exceptUserList = ['angel777.kanan@gmail.com', 'app.angelpro2@gmail.com'];
  // const exceptUserList = [''];

  const excepted = exceptUserList.includes(localdata?.email);

  const MetaEmbeddedUser = localdata?._id === '651d174fc961206e54c77ed3';
  // const MetaEmbeddedUser = localdata?._id === '651d174fc961206e54c77ed3' || localdata?._id === '6489675b4f598e055ed74e34';

  const checkDashboardAPICall = () => {
    let token = authtoken;
    checkDashboardEvents(token).then((res) => {
      if (res?.flag) {
        setDashboardEvent(res?.data);
      } else {
        console.log('error ', res);
      }
    });
  };

  const waStatusApiCall = () => {
    let token = authtoken;
    waStatus(token).then((res) => {
      if (res?.flag) {
        setWaStatusData(res?.data);
      } else {
        console.log('error ', res);
      }
    });
  };

  useEffect(() => {
    if (DashboardEvent) {
      console.log('dddddd ', DashboardEvent);
      console.log('dddddd ', DashboardEvent?.WhatsApp);
    }
  }, [DashboardEvent]);

  const signupV2status = () => {
    console.log('signupV2status');
    let data = {
      facebook_id: localdata?.facebook_id,
      is_v2_user: 'true',
    };
    let token = authtoken;
    userSignupV2Api(data, token).then((res) => {
      if (res?.flag) {
        console.log('v2 status updated successfully', res);
      } else {
        console.log('v2 status update failed', res);
      }
    });
    Helper.EmbeddedAI = false;
  };

  useEffect(() => {
    const login_track = localStorage.getItem('login_event');

    if (login_track === 'true' && localdata) {
      handleTrackEvent('dashboard_login_event', localdata);
      localStorage.setItem('login_event', 'false');
    }
  }, [localdata]);

  useEffect(() => {
    const shopName = localStorage.getItem('shopifyURL');
    setTimeout(() => {
      if (shopName) {
        navigate(`/creator/discoverPlatforms/setupShopify`);
      }
    }, 1000);
  }, []);

  useEffect(() => {
    const onGetFreeTrial = (eventData) => {
      console.log('emitter event data ===> ', eventData);
      setIsFTPOpen(eventData.isFree);
    };
    const listener = EventEmitter.addListener('get_free_trial', onGetFreeTrial);
    return () => {
      listener.remove();
    };
  }, []);

  useEffect(() => {
    const appSumoWelcomeModal = () => {
      setShowWelcomeModal(true);
    };
    const listener = EventEmitter.addListener('appSumoWelcome', appSumoWelcomeModal);
    return () => {
      listener.remove();
    };
  }, []);

  useEffect(() => {
    const onFreeTrialSuccess = (eventData) => {
      console.log('emitter event data ===> ', eventData);
      setFTPSuccess(eventData.isFree);
      setIsFTPOpen(eventData.isFree);
    };
    const listener = EventEmitter.addListener('show_free_trial_success', onFreeTrialSuccess);
    return () => {
      listener.remove();
    };
  }, []);

  useEffect(() => {
    const reviewed = localStorage.getItem('reviewed');
    const sessionReview = sessionStorage.getItem('reviewClose');
    if (reviewed || sessionReview) {
      setShowreviewModal(false);
    } else {
      setShowreviewModal(true);
    }
  }, []);

  useEffect(() => {
    waStatusApiCall();

    if (agentdata?._id) {
      console.log('getagent fnc calll');
      console.log('getagent fnc calll');
      console.log('getagent fnc calll');
      console.log('getagent fnc calll');
      V2GetAgentAPICall();
    }
  }, []);

  const V2GetAgentAPICall = () => {
    let token = authtoken;
    V2SingleGetAgent(token).then((res) => {
      if (res?.flag) {
        dispatch({ type: 'addAgentdata', payload: res?.data });
      } else {
        toast.error('Unable to fetch agent details at this moment. Login again later.', {
          position: 'top-center',
        });
        googleLogout();
        dispatch({ type: 'redirectToLogin', payload: true });
        dispatch({ type: 'logout' });

        localStorage.removeItem('token');
        navigate('/login');
      }
    });
  };

  useEffect(() => {
    if (localdata) {
      // if(!localdata?.free_trail?.status && !localdata?.free_trail?.used_status){
      //   setIsFTPOpen(false);
      // }

      if (Helper.EmbeddedAI == true) {
        signupV2status();
      }
    }
  }, [localdata]);

  // const adminLogin = () => {
  //   console.log("admin login called");
  //   let data = {
  //     email: process.env.REACT_APP_ADMIN_ID,
  //     password: process.env.REACT_APP_ADMIN_PASSWORD,
  //   };
  //   loginADMIN(data).then((res) => {
  //     if (res?.flag) {
  //       setAuthToken(res.token);
  //       console.log("admin login successful");
  //     } else {
  //       console.log(res);
  //     }
  //   });
  // };

  useEffect(() => {
    if (!isWAOpen) {
      getuserapicall();
    }
  }, [isWAOpen]);

  useEffect(() => {
    if (authtoken?.length > 0) {
      dispatch({ type: 'addAuthToken', payload: authtoken });
      console.log('redux authtoken added');
      // callSignupV2api();
      getuserapicall();
      getlabellistapicall();
    }
  }, []);

  const getlabellistapicall = () => {
    let token = authtoken;
    // contactlabellistAPI(token).then((res) => {
    contactlabellistWithoutCountAPI(token).then((res) => {
      if (res?.flag) {
        setLabelList(res.data.labelList);
        console.log('6666666666', res);
      } else {
        console.log('err===>', res);
      }
    });

    // contactlabellistWithoutCountAPI(token).then((res) => {
    //   if (res.flag) {
    //     setLabelList(res.data.labelList);
    //     console.log('6666666666', res);
    //   } else {
    //     console.log('err===>', res);
    //   }
    // });
  };

  const getuserapicall = () => {
    let token = authtoken;
    getUserApi(token).then((res) => {
      // console.log('get user api response ==> ', res);
      if (res?.flag) {
        dispatch({ type: 'addLocaldata', payload: res?.data });
        setIsLoading(false);
      } else {
        dispatch({ type: 'redirectToLogin', payload: true });
        dispatch({ type: 'logout' });
        localStorage.removeItem('token');
        console.log('triggered');

        navigate('/');
        toast.error(res?.message);
      }
    });
  };

  const scrollRef = useRef(null);
  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 250; // Adjust scroll distance
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  const isPremiumUser = localdata?.premium || localdata?.free_trail?.status;
  const isChatLoad = localdata?.metaConfig?.instagramPageName ?? false;
  const onlyPremium = localdata?.premium;
  const getTodaysDate = () => {
    const date = new Date();
    const mm = date.toLocaleString('en-EN', { month: 'short' });
    const dd = date.getDate();
    const yy = date.getFullYear();
    const DD = date.toLocaleDateString('en-EN', { weekday: 'long' });
    return dd + '’ ' + mm + ' ' + yy;
  };

  const getRemainingDays = (e) => {
    const d = new Date(e);
    const date = new Date();
    let dd = d.toDateString();
    let cd = date.toDateString();
    let diff = Math.floor((Date.parse(dd) - Date.parse(cd)) / 86400000);
    if (diff < 0) diff = 0;
    return diff;
  };

  const remainingDays = getRemainingDays(localdata?.free_trail?.end_date);

  const AutoSubmitTemplatesAPIcall = () => {
    let data = {
      user_id: localdata._id,
    };
    let token = authtoken;
    AutoSubmitTemplates(data, token).then((res) => {
      if (res.flag) {
        console.log('auto submit success res ===>', res);
      } else {
        console.log('auto submit fail res ===>', res);
      }
    });
  };

  useEffect(() => {
    if (EmbeddedOpen) {
      console.log('embeddedOpen set to true');
      setIsEmbeddedModalOpen(true);
    }
  }, [EmbeddedOpen]);

  useEffect(() => {
    if (!isEmbeddedModalOpen) {
      setEmbeddedOpen(false);
    }
  }, [isEmbeddedModalOpen]);

  const checkWAStatusAPIcall = () => {
    let data = {
      user_id: localdata?._id,
    };
    let token = authtoken;
    EmbeddedCheckWAStatus(data, token).then((res) => {
      if (res?.flag) {
        // console.log('success response: ', res);
        setWAStatus(res?.data?.result?.verificationStatus === 'verified' ? true : false);
      } else {
        console.log('error response: ', res);
      }
    });
  };

  const scrollContainerRef = useRef(null);

  const sumoScroll = (direction) => {
    if (scrollContainerRef.current) {
      const scrollAmount = 300;
      scrollContainerRef.current.scrollTo({
        left: scrollContainerRef.current.scrollLeft + (direction === 'left' ? -scrollAmount : scrollAmount),
        behavior: 'smooth',
      });
    }
  };

  const getAllSenderIdApiCall = () => {
    const token = authtoken;
    getAllSenderId(token).then((res) => {
      if (res?.flag) {
        console.log('getAll sender id', res);
        if (res?.data && res?.data[0]?.verified?.status) {
          if (Object.keys(res?.data).length > 0) {
            setSenderId(true);
          }
        }
      } else {
        // toast(res?.message, { position: 'top-center' });
      }
    });
  };
  useEffect(() => {
    projectQualityStatus();
    getAllSenderIdApiCall();
    fetchNotifications();
  }, []);

  const projectQualityStatus = () => {
    let data = {
      user_id: localdata?._id,
    };
    let token = authtoken;
    getProjectQualityStatus(data, token).then((res) => {
      if (res?.flag) {
        // console.log('success response: ', res);

        setWaQualityStatus(res?.data?.result?.data);
      } else {
        console.log('error response: ', res);
      }
    });
  };

  const switchToPartnerAction = () => {
    let token = authtoken;
    switchToPartner(token).then((res) => {
      if (res?.flag) {
        let partnerWindow = window.open(`${window.location.origin}/partner`, '_blank');
        if (partnerWindow) {
          partnerWindow.partnerCheerioToken = res?.data;
        } else {
          toast.error('Failed to open partner window. Please check your popup blocker settings.', {
            position: 'top-right',
          });
        }
      } else {
        toast.error('There is no partner account linked to this account', {
          position: 'top-right',
        });
      }
    });
  };

  useEffect(() => {
    let timer = setInterval(() => {
      if (!isLoading) {
        clearInterval(timer);
      }

      if (isLoading && count < 90) {
        setCount((prev) => prev + 1);
      } else {
        clearInterval(timer);
      }
    }, 200);

    return () => clearInterval(timer);
  }, [isLoading, count]);

  useEffect(() => {
    if (localdata?._id == '6489675b4f598e055ed74e34') {
      Beacon.setRouter((path) => {
        navigate(path);
      });
    }
  }, [navigate]);

  // useEffect(() => {
  //   if (isLoading) {
  //     const timer = setInterval(() => {
  //       setCount((oldCount) => {
  //         if (oldCount == 90 || !isLoading) clearInterval(timer);
  //         return Math.min(oldCount + 1, 90);
  //       });
  //     }, 200);
  //   }
  // }, [isLoading]);

  const getDate = (e) => {
    const d = new Date(e);
    let dd = d.getDate();
    let mm = (d.getMonth() + 1).toString().padStart(2, '0');
    let yy = d.getFullYear().toString().slice(-2);
    return dd + '/' + mm + '/' + yy;
  };

  const handleAddBalanceClick = () => {
    handleTrackEvent('dashboard_add_balance_button_clicked', localdata);
    if (autorechargdata?.length >= 0 && walletCurrency && walletCurrency !== 'USD') {
      setrechargeafterAutotopupsetModel(true);
    } else {
      if (walletCurrency) {
        eventsend('Add_balance_wallet_dashboard_clicked');
        setIsAddTopUpModalOpen(true);
      } else {
        setShowDefaultCurrencyModal(true);
      }
    }
  };

  useEffect(() => {
    if (localdata) {
      trackPages('dashboard_page', localdata);
    }
  }, []);

  // const handleTrackLinks = (link, linkName) => {
  //   if (localdata?.email !== "priam@cheerio.in") {
  //     try {
  //       const data = {
  //         email: localdata?.email,
  //         link: link,
  //         properties: {
  //           userId: localdata?._id,
  //           userName: localdata?.name,
  //           userPhone: localdata?.mobile,
  //           companyName: localdata?.company_name,
  //           name: linkName
  //         }
  //       }
  //       const response = trackLink(data)
  //       if (response?.flag) {
  //         console.log('track link success')
  //       } else {
  //         console.log('track link failed')
  //       }
  //     } catch (error) {
  //       console.log('track link error', error)
  //     }
  //   }
  // }

  // const handleTrackEvent = async (event) => {
  //   if (localdata?.email !== "priam@cheerio.in") {
  //     try {
  //       const data = {
  //         email: localdata?.email,
  //         event: event,
  //         properties: {
  //           userId: localdata?._id,
  //           userName: localdata?.name,
  //           userPhone: localdata?.mobile,
  //           companyName: localdata?.company_name,
  //           isAppsumoUser: localdata?.isAppsumoUser,
  //         }
  //       }
  //       const response = await trackEvent(data)
  //       if (response?.flag) {
  //         console.log('event tracked successfully')
  //       }
  //       else {
  //         console.log('error in track event')
  //       }
  //     } catch (error) {
  //       console.log('error in track event', error);
  //     }
  //   }
  // }

  if (isLoading) {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center" style={{ marginTop: '40vh' }}>
        <NewLoader></NewLoader>
        <p style={{ fontSize: '16px', fontWeight: '600' }}>{count + '%'}</p>
      </div>
    );
  }

  return (
    <div className="creator">
      {showAiAgentFeatureBanner && <AiAgentFeatureBanner onClose={() => setShowAiAgentFeatureBanner(false)} />}

      {showWelcomeModal && <AppsumoWelcomeModal show={showWelcomeModal} setShow={setShowWelcomeModal} />}
      {isQRModalOpen && <QRModal setIsQRModalOpen={setIsQRModalOpen} />}

      {isAPModalOpen && <AddPeopleModal setIsAPModalOpen={setIsAPModalOpen} />}

      {isAgentPermModalOpen && <AgentPermModal setIsAPModalOpen={setIsAgentPermModalOpen} />}

      {localdata?.isAppsumoUser && showreviewModal && <AppSumoReviewModal showreviewModal={showreviewModal} setShowreviewModal={setShowreviewModal} />}

      {PRWAModalOpen && (
        <PreReqWASetup
          setIsModalOpen={setPRWAModalOpen}
          proceedToSetup={() => {
            setIsWAPresetupModalOpen(true);
            setPRWAModalOpen(false);
          }}
        />
      )}

      {isAddTopUpModalOpen && walletCurrency === 'INR' ? (
        <AutomaticRechargeModal
          setAutomaticrechargemodalopen={setIsAddTopUpModalOpen}
          isAutomaticrechargemodalopen={isAddTopUpModalOpen}
          setIsPaymentSuccessModalOpen={setIsPaymentSuccessModalOpen}
          fetchautorechargedetails={() => fetchautorechargedetails()}
          setIsonetimerechargeSucceesmodelopen={setIsonetimerechargeSucceesmodelopen}
        />
      ) : (
        <AddTopUpModal setIsAddTopUpModalOpen={setIsAddTopUpModalOpen} isAddTopUpModalOpen={isAddTopUpModalOpen} />
      )}
      {isPaymentSuccessModalOpen && (
        <AutotopupSuccesModel setPSModalOpen={setIsPaymentSuccessModalOpen} fetchautorechargedetails={() => fetchautorechargedetails()} />
      )}
      {isonetimerechargeSucceesmodelopen && (
        <OneTimeRechargeSuccessmodel
          onetimerechargeSuccessModal={setIsonetimerechargeSucceesmodelopen}
          fetchautorechargedetails={() => fetchautorechargedetails()}
        />
      )}
      {rechargeafterAutotopupsetModel && (
        <RechargeAfterAutoTopUpsetModal
          setAutomaticrechargemodalopen={setrechargeafterAutotopupsetModel}
          isAutomaticrechargemodalopen={rechargeafterAutotopupsetModel}
          setIsonetimerechargeSucceesmodelopen={setIsonetimerechargeSucceesmodelopen}
        />
      )}
      {showCurrencyDefaultModal && (
        <DefaultCurrencyModal setShowDefaultCurrencyModal={setShowDefaultCurrencyModal} showCurrencyDefaultModal={showCurrencyDefaultModal} />
      )}

      {emailModalOpen && (
        <BuyCreditsModal
          isOpen={emailModalOpen}
          onClose={() => setEmailModalOpen(false)}
          availableBalance={walletBalance}
          walletCurrency={walletCurrency}
          authtoken={authtoken}
        />
      )}

      {showPremiumModal && (
        <PremiumModal setShowPremiumModal={setShowPremiumModal} showPremiumModal={showPremiumModal} planName="Basic" planDuration="Quarterly" currency="INR" />
      )}

      {isHistoryModalOpen && (
        <HistoryModal
          setIsHistoryModalOpen={setIsHistoryModalOpen}
          isHistoryModalOpen={isHistoryModalOpen}
          onAddBalance={handleAddBalanceClick}
          isAutomationTaskModalOpen={isAutomationTaskModalOpen}
          setIsAutomationTaskModalOpen={setIsAutomationTaskModalOpen}
        />
      )}
      {isAutomationTaskModalOpen && (
        <AutomationTaskModal
          isAutomationTaskModalOpen={isAutomationTaskModalOpen}
          setIsAutomationTaskModalOpen={setIsAutomationTaskModalOpen}
          setIsHistoryModalOpen={setIsHistoryModalOpen}
        />
      )}

      {isAutomationTaskModalOpen && (
        <AutomationTaskModal
          isAutomationTaskModalOpen={isAutomationTaskModalOpen}
          setIsAutomationTaskModalOpen={setIsAutomationTaskModalOpen}
          setIsHistoryModalOpen={setIsHistoryModalOpen}
        />
      )}
      {isWAPresetupModalOpen && (
        <WAPreSetupModal
          MetaEmbedded={false}
          // MetaEmbedded={MetaEmbeddedUser}
          AISensyEmbedded={true}
          // AISensyEmbedded={
          //   (Helper.EmbeddedAI == true ||
          //     localdata?.is_v2_user == true ||
          //     localdata?.ai_sensy_whatsapp_config == true) &&
          //   !MetaEmbeddedUser
          // }
          setIsWAPreSetupOpen={setIsWAPresetupModalOpen}
          onclickAction={() => {
            window.FB.login(
              function (response) {
                console.log({ response });
                if (response.authResponse) {
                  const code = response.authResponse.accessToken;
                  // console.log("CODE CODE CODE => ", code);
                  dispatch({ type: 'tempFBToken', payload: code });
                  eventsend('Proceed_to_setup_WhatsApp_setup_pop_up_Clicked');
                  // window.launchWhatsAppSignup();
                  setIsEmbeddedModalOpen(true);
                  // The returned code must be transmitted to your backend,
                  // which will perform a server-to-server call from there to our servers for an access token
                } else {
                  console.log('User cancelled login or did not fully authorize.');
                }
              },
              {
                scope: 'whatsapp_business_management',
                // response_type: 'code', // must be set to 'code' for System User access token
                // override_default_response_type: true, // when true, any response types passed in the "response_type" will take precedence over the default types
                // sessionInfoVersion: 2, //  Receive Session Logging Info
                extras: {
                  feature: 'whatsapp_embedded_signup',
                  setup: {
                    solutionID: '883160333502568',
                  },
                },
              }
            );
          }}
          onClickApply={() => {
            setIsEmbeddedModalOpen(true);
          }}
          openEmbedded={() => {
            console.log('setEmbeddedOpen to true');
            setEmbeddedOpen(true);
          }}
          WAStatus={WAStatus}
        />
      )}

      {openWATemplate && (
        <WATemplate
          setOpenWATemplate={setOpenWATemplate}
          proceedtoTemplate={proceedtoTemplate}
          goToTemplate={() => {
            setOpenWATemplate(false);
            setAutoSubmit(true);
            setIsTemplateOpen(true);
          }}
        />
      )}
      {isWARefreshOpen && <WARefreshModal setIsWARefreshOpen={setIsWARefreshOpen} />}
      {isEmbeddedModalOpen && (
        <EmbeddedModal
          setIsEmbeddedModalOpen={setIsEmbeddedModalOpen}
          setIsWAPresetupModalOpen={setIsWAPresetupModalOpen}
          setSetupComplete={setSetupComplete}
          openEmbeddedAction={EmbeddedOpen}
          checkWAStatusAction={() => {
            checkWAStatusAPIcall();
          }}
        />
      )}

      {setupComplete && <WhatsAppSetupModal setSetupComplete={setSetupComplete} setupComplete={setupComplete} />}

      {profilePopup && (
        <ProfilePopup
          setProfilePopup={(e) => {
            setProfilePopup(e);
          }}
        />
      )}
      {/* {isFTPOpen && (
        <FreeTrialPlans
          setIsOpen={setIsFTPOpen}
          centerstyle={{ transform: 'translate(-50%,-50%)' }}
          isSuccess={FTPSuccess}
          onsuccess={() => {
            getuserapicall();
          }}
        />
      )} */}
      {openICModal && <ICNewModal setOpenICModal={setOpenICModal} />}
      {openANModal && (
        <AnnNewModal
          setOpenANModal={setOpenANModal}
          EmailBuilder={ANMEMailBuilder}
          fromhomepage={true}
          UploadFromHome={uploadHTMLHome}
          setOpenCampaignModal={setOpenCampaignModal}
          opencampaignmodal={opencampaignmodal}
        />
      )}
      {/* {isFTMOpen && (
        <FreeTrialModal
          setIsOpen={setIsFTMOpen}
          onsuccess={() => {
            getuserapicall();
          }}
        />
      )} */}
      {isWAOpen && (
        <SetupWA
          setIsOpen={setIsWAOpen}
          onclick={() => {
            console.log('setup wa click');
            eventsend('Setup_WhatsApp_home_page_clicked');
          }}
          gotowebhooksetup={() => {
            setIsWAOpen(false);
            setIsWebhookOpen(true);
          }}
          proceedtoTemplate={() => {
            AutoSubmitTemplatesAPIcall();
            setIsWAOpen(false);
            setProceedtoTemplate(true);
            setOpenWATemplate(true);
          }}
        />
      )}
      {isWebhookOpen && <SetupWebhook setIsWebhookOpen={setIsWebhookOpen} />}
      {isDownloadCreditOpen && <DownloadCredit setIsDownloadCreditOpen={setIsDownloadCreditOpen} />}
      {isTemplateOpen && (
        <TemplateModal
          setIsTemplateOpen={setIsTemplateOpen}
          backAction={() => {
            setIsTemplateOpen(false);
            setOpenWATemplate(true);
          }}
          gotowebhook={() => {
            setIsTemplateOpen(false);
            setIsWebhookOpen(true);
          }}
        />
      )}
      {isSMSOpen && (
        <SetupSMS
          setIsOpen={setIsSMSOpen}
          onclick={() => {
            console.log('setup sms click');
            eventsend('Setup_SMS_home_page_clicked');
          }}
        />
      )}

      {openSenderIdModal && <SenderIdModal openSenderIdModal={openSenderIdModal} setOpenSenderIdModal={setOpenSenderIdModal}></SenderIdModal>}

      {isSMSDLTModalOpen && <SMSDLTModal setIsOpenSMSDLTModal={setIsSMSDLTModalOpen} />}

      {/* {location.pathname === '/creator' &&
        <CheerioWidget
          openReferralModalAction={() => {
            setIsReferralModalOpen(true);
          }}
        />
      } */}

      {isReferralModalOpen && <ReferralModal setIsReferralModalOpen={setIsReferralModalOpen} token={authtoken} />}

      {/* Creator Header */}
      {window.innerWidth < 900 && (
        <Header
          setSidemenuCollapse={() => setSidemenuCollapse(!sidemenuCollapse)}
          setIsFTMOpen={setIsFTMOpen}
          setProfilePopup={() => {
            setProfilePopup(!profilePopup);
          }}
        />
      )}

      {/* Creator Body */}
      <div className="creator__body">
        {/* Sidemenu */}
        <SidemenuNew
          notPremiumUser={() => {
            setIsFTMOpen(true);
          }}
          sidemenuCollapse={sidemenuCollapse}
          setSidemenuCollapse={setSidemenuCollapse}
          openInviteMembersAction={() => {
            setIsAPModalOpen(true);
          }}
          setProfilePopup={() => {
            setProfilePopup(!profilePopup);
          }}
          openProfileAction={() => {
            console.log('opennnnnn');
          }}
          openReferralModalAction={() => {
            setIsReferralModalOpen(true);
          }}
          uploadHTMLAction={() => {
            handleTrackEvent('dashboard_upload_html_button_clicked', localdata);
            if (!agentdata?.permission?.campaign && agentdata && isPremiumUser) {
              setIsAgentPermModalOpen(true);
            } else if (isPremiumUser) {
              setANMEmailBuilder(true);
              setUploadHTMLHome(true);
              setOpenANModal(true);
            } else {
              setIsFTMOpen(true);
            }
          }}
        />

        {/* BODY Container */}
        <div
          className="creator__body__container"
          onClick={() => {
            if (MobileWidth) {
              setSidemenuCollapse(true);
            }
          }}
          style={{
            width: MobileWidth ? '100%' : 'calc( 100% - 75px )',
            // : sidemenuCollapse
            // ? 'calc( 100% - 60px)'
            // : 'calc( 100% - 240px )',
          }}
        >
          {/* Home Page Creator Route */}
          {location.pathname === '/creator' && (
            <>
              {/* Deployment Banner */}
              {localdata?.deployment && <DeploymentBanner />}

              {/* Welcome Header */}
              <div className="welcome_row border-bottom sticky-top">
                {!MobileWidth && <h2>{'Dashboard'}</h2>}

                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                  {!MobileWidth && (localdata?.isAppsumoUser || localdata?._id === '65ee7dd6362208d14232e2da') && (
                    <>
                      <div
                        style={{
                          padding: '5px 12px',
                          borderRadius: '10px',
                          border: 'none',
                          alignItems: 'center',
                          position: 'relative', // Necessary for absolute positioning
                          overflow: 'hidden', // Hi
                          border: '1px solid #CCCCCC',
                          borderRadius: '10px',
                          color: '#666666',
                          fontSize: '10px',
                          cursor: 'pointer',
                        }}
                        onClick={() => {
                          handleTrackLinks(`${window.location.origin}/partner`, 'dashboard_switch_workspace_clicked', localdata);
                          switchToPartnerAction();
                        }}
                      >
                        <div className="d-flex flex-row align-items-center gap-3">
                          <p>{'Login to partner dashboard'}</p>
                          <MdArrowForwardIos height={5} />
                        </div>
                      </div>
                    </>
                  )}
                  {!MobileWidth &&
                    (localdata?.isAppsumoUser ? (
                      <>
                        <div
                          style={{
                            padding: '5px 12px',
                            borderRadius: '10px',
                            border: 'none',
                            alignItems: 'center',
                            position: 'relative', // Necessary for absolute positioning
                            overflow: 'hidden', // Hi
                            border: '1px solid #CCCCCC',
                            borderRadius: '10px',
                            color: 'white',
                            fontSize: '10px',
                            cursor: 'pointer',
                            background: colors.darkPurple,
                          }}
                          onClick={() => {
                            navigate('/addons');
                          }}
                        >
                          <div className="d-flex flex-row align-items-center gap-3">
                            <p>{'Explore Add Ons'}</p>
                            <MdArrowForwardIos height={5} />
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        {localdata?.premium_details && Object.keys(localdata?.premium_details).length > 0 && (
                          <h4
                            style={{
                              fontSize: '14px',
                              border: '1px solid black',
                              borderRadius: '8px',
                              padding: MobileWidth ? '16px' : '8px',
                              cursor: 'pointer',
                            }}
                            onClick={() => {
                              if (localdata?.premiumPlanName == 'Enterprise') {
                                navigate('/premiumplans');
                              } else {
                                navigate('/premiumpricing');
                              }
                            }}
                          >
                            {`${localdata?.premium_details?.plan_type} plan: Renewal on ${getDate(localdata?.premium_details?.plan_end)}`}
                          </h4>
                        )}
                      </>
                    ))}

                  {!MobileWidth && (
                    <>
                      <div
                        className="Row justify-content-start px-3 py-2"
                        style={{ height: 40, width: 'auto', backgroundColor: colors.white03, borderRadius: 8, cursor: 'pointer' }}
                        onClick={() => {
                          setWalletOBModalOpen(true);
                        }}
                      >
                        <img src={images.OBWalletGrey} style={{ height: 24, width: 24, objectFit: 'contain' }} />
                        <p style={{ color: colors.black04, paddingInlineStart: 4 }}>
                          {walletCurrency === 'INR' ? `₹${walletBalance ?? 0}` : `$${walletBalance ?? 0}`}
                        </p>
                      </div>
                    </>
                  )}

                  {walletOBModalOpen && (
                    <WalletModalOB
                      setIsModalOpen={setWalletOBModalOpen}
                      walletBalance={walletBalance}
                      walletCurrency={walletCurrency}
                      onclickAddBalance={() => {
                        handleTrackEvent('dashboard_add_balance_button_clicked', localdata);
                        if (autorechargdata?.length >= 0 && walletCurrency != 'USD') {
                          setrechargeafterAutotopupsetModel(true);
                        } else {
                          if (walletCurrency) {
                            eventsend('Add_balance_wallet_dashboard_clicked');
                            setIsAddTopUpModalOpen(true);
                          } else {
                            setShowDefaultCurrencyModal(true);
                          }
                        }
                      }}
                      onclickPaymentHistory={() => {
                        if (walletCurrency) {
                          setIsHistoryModalOpen(true);
                        } else {
                          setShowDefaultCurrencyModal(true);
                        }
                      }}
                    />
                  )}

                  {!MobileWidth && (
                    <div
                      className="notification"
                      style={{}}
                      onClick={() => {
                        eventsend('Contact_support_help_navigation_bar_clicked');
                        handleTrackEvent('sidebar_profile_button_clicked', localdata);
                        setProfilePopup(true);
                        console.log('i am clicked');
                      }}
                    >
                      <div
                      // className="lower_element"
                      >
                        {/* <Tooltip title={'Profile'}> */}
                        {agentdata?.profileImg || localdata?.picture ? (
                          <>
                            <HEImages
                              userGeneratedSrc={agentdata?.profileImg ? agentdata?.profileImg : localdata?.picture && getImagePath(localdata?.picture)}
                              classname={`${styles['HeaderProfileImage']} ${localdata?.premium ? 'bordergradient' : ''}`}
                            />
                            {/* <p style={{ fontWeight: '600', paddingTop: '4px' }}>Manage Profile</p> */}
                          </>
                        ) : (
                          <>
                            <img
                              src={images.ProfilePic}
                              className={`${styles['HeaderProfileImage']} ${localdata?.premium ? 'bordergradient' : ''}`}
                              onClick={() => {
                                eventsend('Manage Profile_navigation_bar_clicked');
                                // setProfilePopup();
                              }}
                            ></img>
                            {/* <p style={{ fontWeight: '700' }}>Manage Profilejtkglhlkj</p> */}
                          </>
                        )}
                        {/* </Tooltip> */}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="content_container_new">
                {isModalOpen && localdata?.isEmailBlocked && <WarningModal onClose={handleClose} />}
                {isBounceModalOpen && localdata?.isBounceWarning && <BounceWarningModal onClose={handleBounceModalClose} />}
              </div>

              <div className="w-100 h-100 Column justify-content-start px-4 py-2">
                {/* Welcome get started */}
                {isChatLoad ? (
                  <>
                    <div
                      className="Row w-100"
                      style={{
                        border: `1px solid ${colors.borderwhite}`,
                        borderRadius: 12,
                        background: `url(${images.OBBanner})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        padding: 24,
                        marginBlockEnd: 20,
                      }}
                    >
                      <img src={images.OBRocket} style={{ height: 30, width: 30, objectFit: 'contain', marginInlineEnd: 16 }} />
                      <div className="Column align-items-start" style={{ flex: 1 }}>
                        <h3 style={{ fontWeight: 600, color: colors.white01 }} className="mb-2">
                          {'Get 30% more leads on Meta ads!'}
                        </h3>
                        <p style={{ color: colors.white01 }}>{'Run Click-to-Instagram DM Ads Today'}</p>
                      </div>
                      <div className="Column px-2" style={{}}>
                        <CheerioButton
                          borderStyle={{ borderColor: colors.black }}
                          textStyle={{ color: colors.black }}
                          btnText={'Learn More'}
                          onclick={() => {
                            window.open('https://www.omnybox.com/post/how-to-run-click-to-dm-ads-to-get-more-leads', '_blank');
                          }}
                        />
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      className="Row w-100"
                      style={{
                        border: `1px solid ${colors.borderwhite}`,
                        borderRadius: 12,
                        backgroundColor: colors.white01,
                        padding: 24,
                        marginBlockEnd: 20,
                      }}
                    >
                      <div className="Column align-items-start" style={{ flex: 1 }}>
                        <h3 style={{ fontWeight: 600 }} className="mb-2">
                          {'Hello, '}
                          <span
                            style={{
                              color: colors.primary02,
                            }}
                          >{`${localdata?.name}!`}</span>
                        </h3>
                        <p>{'Welcome to Omnybox, Here are the few things for you to get started with your First Automation.'}</p>
                      </div>
                      <div className="Column px-2" style={{}}>
                        <CheerioButton
                          btnText={'Get started'}
                          onclick={() => {
                            navigate('/creator/instagramReplies');
                          }}
                        />
                      </div>
                    </div>
                  </>
                )}

                {/* New Setup */}
                <div className="Column w-100" style={{ marginBlock: 20, rowGap: 20 }}>
                 {localdata?.premiumPlanName !== 'Free_OB_6Mths' && (
                 <ChannelChecklist
                    channelNumber={1}
                    title="Email Channel"
                    subtitle="Setup email channel on omnybox to start your email automation journey"
                    steps={EMAIL_STEPS}
                    completionMap={emailCompletion}
                    onBlockedAttempt={(step) => onBlocked(step.label)}
                    onClickAction={handleChecklistAction}
                  />
                 )}
                  

                  <ChannelChecklist
                    channelNumber={localdata?.premiumPlanName !== 'Free_OB_6Mths' ? 2 : 1}
                    title="Instagram Channel"
                    subtitle="Connect your Instagram account to Omnybox and automate your social media presence"
                    steps={INSTAGRAM_STEPS}
                    completionMap={igCompletion}
                    onBlockedAttempt={(step) => toast.info(`Finish the previous step(s) before “${step.label}”.`)}
                    onClickAction={handleChecklistAction}
                  />           

                  <ChannelChecklist
                    channelNumber={localdata?.premiumPlanName !== 'Free_OB_6Mths' ? 3 : 2}
                    title="Meta Ads Optimizer"
                    subtitle="Connect your Meta Ads Manager account with Omnybox and start optimizing your Ad leads & Revenue"
                    steps={META_STEPS}
                    completionMap={metaCompletion}
                    onBlockedAttempt={(step) => toast.info(`Finish the previous step(s) before “${step.label}”.`)}
                  />
                 {localdata?.premiumPlanName !== 'Free_OB_6Mths' && (

                  <ChannelChecklist
                    channelNumber={4}
                    title="RCS Channel"
                    subtitle="Setup your RCS channel with Omnybox to send and automate Rich-Media Messages to your recipients"
                    steps={RCS_STEPS}
                    completionMap={rcsCompletion}
                    onBlockedAttempt={(step) => toast.info(`Finish the previous step(s) before “${step.label}”.`)}
                  />
                 )}
                 {localdata?.premiumPlanName !== 'Free_OB_6Mths' && (
                  <ChannelChecklist
                    channelNumber={5}
                    title="SMS Channel"
                    subtitle="Setup your SMS channel with Omnybox to send and automate Messages globally to your recipients"
                    steps={SMS_STEPS}
                    completionMap={smsCompletion}
                    onBlockedAttempt={(step) => toast.info(`Finish the previous step(s) before “${step.label}”.`)}
                  />
                 )}

                </div>
              </div>
            </>
          )}
          <Routes>
            <Route path="contacts/:id/*" element={<ContactModule excepted={excepted} />} />
            <Route path="announcements" element={<AnnouncementsNew />} />
            <Route path="analytics" element={<CreatorAnalyticsNew excepted={excepted} />} />
            <Route path="shopifystore" element={<ShopifyStore />} />
            <Route path="woocommerce" element={<WooCommerce />} />
            <Route path="whatsappreplies/*" element={<WhatsAppReplies excepted={excepted} />} />
            <Route path="chatbot" element={<ChatBot />} />
            <Route path="manageSender/*" element={<ManageSender />} />
            <Route path="templates/*" element={<Templates />} />
            <Route path="templates/create" element={<CustomTemplateStart />} />
            <Route path="rcstemplates/create" element={<RCSTemplateCreation />} />
            <Route path="annnewcomp" element={<AnnNewComp />} />
            <Route path="createtemplate" element={<CreateTemplate />} />
            <Route path="design" element={<EmailBuilder />} />
            <Route path="workflow" element={<WorkflowTabels />} />
            <Route path="workflowLibrary/preview/:id" element={<WorkflowTemplatePreview />} />
            <Route path="ai-assistants" element={<AIAssistantList />} />
            <Route path="ai-assistants/create" element={<CreateAssistantPage />} />
            <Route path="ai-assistants/edit/:agentId" element={<CreateAssistantPage />} />
            <Route path="ai-assistants/:agentId/token-usage" element={<TokenUsagePage />} />
            <Route path="instagramReplies" element={<InstagramReplies />} />
            <Route path="messengerReplies" element={<MessengerReplies />} />
            <Route path="emailTemplates/edit" element={<EmailBuild />}></Route>
            <Route path="globalAnalytics" element={<GlobalAnalytics excepted={excepted} />}></Route>
            <Route path="agentAnalytics" element={<AgentAnalytics excepted={excepted} />}></Route>
            <Route path="discoverPlatforms/*" element={<DiscoverPlatforms />}></Route>
            <Route path="manageIntegrations/*" element={<ManageIntegrationsPage />}></Route>
            <Route path="keywords" element={<Keywords />}></Route>
            <Route path="timetriggers" element={<TimeTriggers />} />
            <Route path="catalog" element={<Catalog />} />
            <Route path="codPrepaid" element={<CodPrepaidFlow></CodPrepaidFlow>}></Route>
            <Route path="uploadContacts/" element={<ContactMapping />}></Route>
            <Route path="smartForms/*" element={<EmbeddableForms />}></Route>
            <Route path="excelLabel/*" element={<ExcelUpload />}></Route>
            <Route path="vendorsList/*" element={<VendorList />}></Route>
            <Route path="linkedinsequences/*" element={<SequenceHome />}></Route>
            <Route path="Sequences/*" element={<Sequences />}></Route>
            <Route path="metaAds/*" element={<MetaAds />}></Route>
            <Route path="emailVerifier/*" element={<EmailVerifier />}></Route>
            <Route path="setup/*" element={<SetupChannelNew />}></Route>
            <Route path="rcsIntegration" element={<RCSIntegration />}></Route>
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default CreatorNew;
